import { Component } from '@angular/core';

@Component({
  selector: 'app-about-backstage',
  templateUrl: './about-backstage.component.html',
  styleUrls: ['./about-backstage.component.less'],
})
export class AboutBackstageComponent {

}
